// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__U9uEb","active":"Overlay_active__u57o4"};